import React from 'react';
import { cn } from '../../../../../../../../../utils/styles';
import { Button } from '../../../../../../../../../components/Common/UI/Button';
import { useMessageManagerProvider } from '../../../../../../../../context/messageManager';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';
import { IBuilderStep2Data } from '../../../../Data';
import { Empty } from '../../../index';
import ModalDeleteModule from '../../../Modals/Delete';
import QuillRichTextEditor from '../../../../../../../Common/QuillRichTextEditor';

export interface BuilderModuleProps {
  className?: string;
}

function ImageModuleEndOfStatement({ className }: BuilderModuleProps) {
  const { state, handleDispatch } = useMessageManagerProvider();

  const { selected } = state.step2.endOfStatement;
  const isTextTab = selected != null && selected.id === state.step2.endOfStatement.data[1]?.id;

  const handeAddImageModule = () => {
    if (state.step2.endOfStatement.data.length < 10) {
      const newData: IBuilderStep2Data[] = [
        ...state.step2.endOfStatement.data,
        {
          id: crypto.randomUUID(),
          content: [''],
          imageUrl: '',
          qrCode: false,
          eStatement: true,
          criteria: [],
          // textCriteria: [],
        },
      ] as IBuilderStep2Data[];

      handleDispatch({
        step2: { ...state.step2, endOfStatement: { ...state.step2.endOfStatement, data: newData } },
      });
    }
  };

  const handleSetSelected = (item: IBuilderStep2Data, index: number) => {
    const next = index === 1 && !item.content?.length ? { ...item, content: [''] } : item;
    const newData = state.step2.endOfStatement.data.map(el => (el.id === selected?.id ? selected : el));

    handleDispatch({
      step2: {
        ...state.step2,
        endOfStatement: {
          ...state.step2.endOfStatement,
          data: newData,
          selected: next.id !== selected?.id ? next : selected,
        },
      },
    });
  };

  return (
    <div className={cn('bg-lightGray2 h-full border rounded-lg grid grid-rows-[auto,1fr] overflow-hidden', className)}>
      <div className={cn('bg-[#c6cfdb] p-[2px] pb-[3px]', { 'bg-primary': selected })}>
        <div
          className="flex gap-[3px] [&_button]:w-[44px] [&_button]:p-[10px]
        [&_button]:border-white [&_button]:border-[2px] [&_button]:bg-transparent [&_button]:text-white
        [&_button]:hover:text-white"
        >
          {state.step2.endOfStatement.data?.map((el, index) => (
            <Button
              key={el.id}
              variant="outline"
              className={cn({
                '!bg-white !text-addition1 !hover:bg-white': el.id === selected?.id,
              })}
              onClick={() => handleSetSelected(el, index)}
            >
              {index + 1}
            </Button>
          ))}
          <Button className="!bg-transparent" onClick={handeAddImageModule}>
            <Icons.PlusFilled className="mx-auto" />
          </Button>
        </div>
      </div>
      {isTextTab ? (
        <div className="bg-white">
          <div className="whitespace-pre-wrap">
            <QuillRichTextEditor value={selected?.content?.[0] || ''} hideToolbar readOnly />
          </div>
        </div>
      ) : selected?.imageUrl ? (
        <div className="relative group bg-lightGray2 flex items-start">
          <ModalDeleteModule />
          <img
            alt="module"
            src={selected?.qrCode && !selected?.eStatement ? '/infoTrac/images/step-2-QR.png' : selected?.imageUrl}
            className={cn('w-full object-contain overflow-hidden', {
              grayscale: !selected?.eStatement && !selected?.qrCode,
            })}
          />
        </div>
      ) : (
        <Empty placeholder="" />
      )}
    </div>
  );
}

ImageModuleEndOfStatement.defaultProps = {
  className: '',
};

export default ImageModuleEndOfStatement;
